import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";

//Other pages
import Sidebar from "./components/sidebar";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/Registerpage";
import EmailVerification from "./pages/EmailVerification";
import { useAuth } from "./components/AuthProvider"; // Just useAuth since AuthProvider is in index.js
import axios from "axios";
import ReactModal from "react-modal";

// Dashboards
import OrderDashboard from "./pages/Dashboard/OrderDashboard";
import InventoryDashboard from "./pages/Dashboard/InventoryDashboard";
import ServiceDashboard from "./pages/Dashboard/ServiceDashboard";
import ReturnDashboard from "./pages/Dashboard/ReturnDashboard";
import BookingDashboard from "./pages/Dashboard/BookingDashboard";
import SubscriptionDashboard from "./pages/Dashboard/SubscriptionDashboard";
import LiquidationDashboard from "./pages/Dashboard/LiquidationDashboard";
import Dashboard from "./pages/Dashboard/Dashboard";

//Subscription pages
import TransportBooking from "./pages/Subscription/TransportBooking";
import ItemPage from "./pages/Subscription/ItemPage";
import BikeFlowDashboard from "./pages/Subscription/BikeFlowDashboard";
import IncomingBikes from "./pages/Subscription/IncomingBikes";
import OutgoingBikes from "./pages/Subscription/OutgoingBikes";
import CustomerCases from "./pages/Subscription/CustomerCases";
import ServiceParts from "./pages/ServiceParts";
import OrderPickingList from "./pages/Subscription/OrderPickingList";
import Inventory from "./pages/Subscription/Inventory";
import TodoList from "./pages/Subscription/TodoList";
import ServiceBookings from "./pages/Subscription/ServiceBookings";
import Returns from "./pages/Subscription/Returns";
import NewOrders from "./pages/Subscription/NewOrders";

//External Service Booking Pages
import ExternalBookingsTable from "./pages/ExternalService/ExternalServiceBookings";
import ExternalServiceToDoList from "./pages/ExternalService/ExternalServiceToDoList";
import ExternalServiceBikeFlow from "./pages/ExternalService/ExternalServiceBikeFlow";

ReactModal.setAppElement("#root");

axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL;
axios.defaults.withCredentials = true;

function ProtectedRoute({ children }) {
  console.log("ProtectedRoute triggered");
  const { isAuthenticated, updateLastVisited } = useAuth();
  if (!isAuthenticated) {
    updateLastVisited(window.location.pathname);
  }
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function App() {
  console.log("App component rendered");
  const { isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <BrowserRouter>
      {/* toaster */}

      <Toaster
        position="top-right"
        toastOptions={{ style: { fontFamily: "inherit" } }}
      />

      <LayoutWrapper>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/verify-email" element={<EmailVerification />} />

          {/* Dashboard routes */}

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory-dashboard"
            element={
              <ProtectedRoute>
                <InventoryDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/order-dashboard"
            element={
              <ProtectedRoute>
                <OrderDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/service-dashboard"
            element={
              <ProtectedRoute>
                <ServiceDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/return-dashboard"
            element={
              <ProtectedRoute>
                <ReturnDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/booking-dashboard"
            element={
              <ProtectedRoute>
                <BookingDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscription-dashboard"
            element={
              <ProtectedRoute>
                <SubscriptionDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/liquidation-dashboard"
            element={
              <ProtectedRoute>
                <LiquidationDashboard />
              </ProtectedRoute>
            }
          />

          {/* Subscription routes */}

          <Route
            path="/inventory"
            element={
              <ProtectedRoute>
                <Inventory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/todo-list"
            element={
              <ProtectedRoute>
                <TodoList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/service-bookings"
            element={
              <ProtectedRoute>
                <ServiceBookings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/returns"
            element={
              <ProtectedRoute>
                <Returns />
              </ProtectedRoute>
            }
          />
          <Route
            path="/new-orders"
            element={
              <ProtectedRoute>
                <NewOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-cases"
            element={
              <ProtectedRoute>
                <CustomerCases />
              </ProtectedRoute>
            }
          />
          <Route
            path="/order-picking-list"
            element={
              <ProtectedRoute>
                <OrderPickingList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bike-flow-dashboard"
            element={
              <ProtectedRoute>
                <BikeFlowDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/incoming-bikes"
            element={
              <ProtectedRoute>
                <IncomingBikes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/outgoing-bikes"
            element={
              <ProtectedRoute>
                <OutgoingBikes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transport-booking"
            element={
              <ProtectedRoute>
                <TransportBooking />
              </ProtectedRoute>
            }
          />
          <Route
            path="/item-page/:serialNumber"
            element={
              <ProtectedRoute>
                <ItemPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/service-parts"
            element={
              <ProtectedRoute>
                <ServiceParts />
              </ProtectedRoute>
            }
          />

          {/* External booking routes */}
          <Route
            path="/external-service/bookings"
            element={
              <ProtectedRoute>
                <ExternalBookingsTable />
              </ProtectedRoute>
            }
          />

          <Route
            path="/external-service/todo-list"
            element={
              <ProtectedRoute>
                <ExternalServiceToDoList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/external-service/bike-flow"
            element={
              <ProtectedRoute>
                <ExternalServiceBikeFlow />
              </ProtectedRoute>
            }
          />
        </Routes>
      </LayoutWrapper>
    </BrowserRouter>
  );
}

function LayoutWrapper({ children }) {
  const location = useLocation();
  const showSidebar = !["/login", "/register", "/verify-email"].some((path) =>
    location.pathname.startsWith(path)
  );

  return (
    <div className="flex min-h-screen">
      {showSidebar && <Sidebar />}
      <div className={`flex-1 overflow-hidden ${showSidebar ? "ml-64" : ""}`}>
        {children}
      </div>
    </div>
  );
}

export default App;
